const Flags = () => {
  return (
    <div>
      <h4>Flags and Tags go here</h4>
    </div>
  )
}

export default Flags
